import { render, staticRenderFns } from "./WSelect.vue?vue&type=template&id=39c1d467"
import script from "./WSelect.vue?vue&type=script&lang=js"
export * from "./WSelect.vue?vue&type=script&lang=js"
import style0 from "./WSelect.vue?vue&type=style&index=0&id=39c1d467&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports